<script lang="ts" setup>
  import { Icon } from '@skillstown/leap';
  import { useDrawer } from '~~/stores/drawer';
  import TermsAndConditionsModal from '../Modals/TermsAndConditions.vue';
  import SupportModal from '../Modals/SupportModal.vue';

  const drawer = useDrawer();

  function onClickShowTermsAndConditions(): void {
    drawer.open({
      component: TermsAndConditionsModal,
    });
  }

  function onClickShowSupport(): void {
    drawer.open({
      component: SupportModal,
    });
  }
</script>

<template>
  <div class="faq-fixed-icons">
    <div class="faq-fixed-icons__wrapper">
      <div
        class="wrapper__icon-container"
        @click="onClickShowTermsAndConditions"
      >
        <Icon
          icon="questionmark"
          color=""
        />
      </div>
      <div
        class="wrapper__icon-container"
        @click="onClickShowSupport"
      >
        <Icon
          icon="info"
          color=""
        />
      </div>
    </div>
  </div>
</template>

<style scoped lang="postcss">
  .faq-fixed-icons {
    @apply fixed bottom-0 right-0 z-[2] px-4 py-4;

    .faq-fixed-icons__wrapper {
      @apply flex items-center justify-center space-x-1;

      .wrapper__icon-container {
        @apply flex h-8 w-8 cursor-pointer items-center justify-center rounded-full border border-gray-500 border-opacity-10 bg-gray-400 p-2 text-white hover:bg-gray-500;
      }
    }

    :deep(svg) {
      filter: brightness(0) saturate(100%) invert(99%) sepia(0%) saturate(1215%) hue-rotate(212deg)
        brightness(113%) contrast(100%);
    }
  }
</style>
